export interface MedicalActivity {
  data: Datum[];
}

 export interface ActivityCode {
  id: string;
  code: string;
  description: string;
  isActive: boolean;
  type: string;
}

export interface Datum {
  id: string;
  name: string;
  codes: ActivityCode[];
  type:  number;
  isActive: any;
}

export const TYPE_CLASS: Record<string, string> = {
  CPT: "cpt",
  HCPCS: "hcpcs",
  Dental: "dental",
};